import { useContext } from 'react';
import { LayoutContext, LayoutContextValue } from './context';

export const useLayoutContext = (): LayoutContextValue => {
	const context = useContext(LayoutContext);

	if (context === undefined) {
		throw new Error('useLayoutContext must be used within a LayoutContextProvider');
	}

	return context;
};
